import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={[classes.WineDinner, classes.vcircus].join(' ')}>
      <Helmet>
        <title>Waterfront Wine Pairings at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>
                  Under the Big Top
                  <br/>
                  <span>An Evening of Wine &amp; Wonder</span>
                </h1>
                <h2 className={classes.bold}>
                  November 5th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $50 Per Guest
                </h2>
                <h3>Featuring United Distributors</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>
          <div className={classes.fun}><div className={classes.insideN}><p>Come Dressed in Your Favorite Circus Attire! Prize for Best Dressed!</p></div></div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>                
                <h5>First Course</h5>
                <h4>Shrimp On a Stick</h4>
                <p>Tempura Battered, Golden Fried Shrimp, Accompanied by House Made Sweet and Sour Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Optimist · Sauvignon Blanc · California Central Coast '25</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Blackened Grouper Street Taco</h4>
                <p>Mini Corn Tortillas, Caribbean Slaw, Cotija Cheese, and Cilantro Chipotle Aioli</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Pessimist · Red Blend · Pasa Robles, California '23</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Lamb Lollipops</h4>
                <p>Caramel Apple Mint Glaze, Sweet Potato Gratin, Roasted Brussels Sprouts</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Realist · Cabernet · Pasa Robles, California '25</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Animal Cracker Tiramisu</h4>
                <p>Mascarpone Custard, Animal Crackers, and Cocoa</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Cerrato · Moscato D' Asti · Piedmont, Italy '24</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner